import { getSite } from '@/utils/getSite';
import { ArticleInfo } from '../types/articleInfo';
import { adsTagSetup, requestMultiVideoBids } from './adsSetup';

export const checkForUserConsentAndGetAdConfig = ({
  articleInfo,
  autostart,
  ypPartId,
  isNativeAd = false,
  isVerticalVideo,
  hideAds,
  hasScrollArticles,
}: {
  articleInfo?: ArticleInfo;
  autostart: string | boolean;
  ypPartId: string | null;
  isNativeAd?: boolean;
  isVerticalVideo?: boolean;
  hideAds?: boolean;
  hasScrollArticles?: boolean;
}): {} => {
  const site = getSite();
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.userConsent) {
      window.userConsent?.isTargetingApproved(async (response: any) => {
        if (!isNativeAd && !hideAds) {
          try {
            let customAdConfig = {};
            if (!['allas'].includes(site)) {
              customAdConfig = await adsTagSetup({
                autoStart: autostart,
                isVerticalVideo,
                hasScrollArticles,
              });
            } else if (response) {
              //Targetting is approved here
              customAdConfig = await requestMultiVideoBids({
                articleInfo,
                autoStart: autostart,
                wasYouplay: ypPartId !== null,
                isVerticalVideo,
                hasScrollArticles,
              });
            }
            resolve(customAdConfig);
          } catch {
            resolve({ noConsent: true });
          }
        } else {
          resolve({ noConsent: true });
        }
      });
    } else {
      resolve({ noConsent: true });
    }
  });
};
